import React from 'react';
import type { InvoiceStatus, ProjectStatus, TaskStatus } from '../../types/portal';
import { INVOICE_STATUS_LABELS, PROJECT_STATUS_LABELS, TASK_STATUS_LABELS } from '../../utils/portalFormat';
type Tone = 'positive' | 'progress' | 'warning' | 'danger' | 'neutral';
const TONES: Record<Tone, string> = {
  positive: 'border-[#6FD39A]/40 text-[#8BE0AF]',
  progress: 'border-[#8DB8FF]/40 text-[#A9C9FF]',
  warning: 'border-[#F5C26B]/45 text-[#F7CF86]',
  danger: 'border-[#FF8B7A]/50 text-[#FFA192]',
  neutral: 'border-line text-muted'
};
const PROJECT_TONE: Record<ProjectStatus, Tone> = {
  draft: 'neutral',
  active: 'progress',
  paused: 'warning',
  completed: 'positive',
  archived: 'neutral'
};
const TASK_TONE: Record<TaskStatus, Tone> = {
  todo: 'neutral',
  in_progress: 'progress',
  review: 'warning',
  done: 'positive'
};
const INVOICE_TONE: Record<InvoiceStatus, Tone> = {
  draft: 'neutral',
  sent: 'progress',
  paid: 'positive',
  overdue: 'danger',
  cancelled: 'neutral',
  refunded: 'neutral'
};
type Props = {
  kind: 'project';
  status: ProjectStatus;
} | {
  kind: 'task';
  status: TaskStatus;
} | {
  kind: 'invoice';
  status: InvoiceStatus;
};
export function StatusBadge(props: Props) {
  const [tone, label] = props.kind === 'project' ? [PROJECT_TONE[props.status], PROJECT_STATUS_LABELS[props.status]] : props.kind === 'task' ? [TASK_TONE[props.status], TASK_STATUS_LABELS[props.status]] : [INVOICE_TONE[props.status], INVOICE_STATUS_LABELS[props.status]];
  return <span className={`inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-[12px] font-medium ${TONES[tone]}`} data-id="element-1053" data-mp="r8oqqmv4wptq">
      <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" data-id="element-1054" data-mp="dai11u0c9w55" />
      {label}
    </span>;
}